import { useContext } from 'react';
import { createNamedContext } from '@utils';
import { ContentFeedContextValue, ContentFeedFetchContextValue } from './interfaces';

export const FetchMoreContentFeedContext = createNamedContext<ContentFeedFetchContextValue>(undefined, 'ContentFeed.FetchMore.Context');
export const FetchContentFeedContext = createNamedContext<ContentFeedFetchContextValue>(undefined, 'ContentFeed.Fetch.Context');
export const ContentFeedContext = createNamedContext<ContentFeedContextValue | undefined>(undefined, 'ContentFeed.Context');

export const useFetchContentFeed = () => useContext(FetchContentFeedContext);
export const useFetchMoreContentFeed = () => useContext(FetchMoreContentFeedContext);